import { render, staticRenderFns } from "./InscricaoView.vue?vue&type=template&id=376c3916&"
import script from "./InscricaoView.vue?vue&type=script&lang=js&"
export * from "./InscricaoView.vue?vue&type=script&lang=js&"
import style0 from "./InscricaoView.vue?vue&type=style&index=0&id=376c3916&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports